import { svg } from "../svg";

export const BitwardenLogo = svg`
  <svg viewBox="0 0 290 45" xmlns="http://www.w3.org/2000/svg">
    <title>GXPMS</title>
    <defs>
      <linearGradient id="gxpms-logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#2563EB"/>
        <stop offset="100%" stop-color="#06B6D4"/>
      </linearGradient>
    </defs>
    <g transform="translate(0, 1)">
      <path d="M 21 2 L 38 11.5 L 38 32.5 L 21 42 L 4 32.5 L 4 11.5 Z" fill="url(#gxpms-logo-grad)"/>
      <path d="M 21 12 L 26 17 L 21 22 L 16 17 Z" fill="#FFFFFF"/>
      <path d="M 19 20 L 23 20 L 23.5 31 L 18.5 31 Z" fill="#FFFFFF"/>
      <path d="M 4 22 L 11 22 L 13 20" stroke="#FFFFFF" stroke-width="1.2" fill="none" opacity="0.7" stroke-linecap="round"/>
      <circle cx="4" cy="22" r="1.5" fill="#FFFFFF" opacity="0.7"/>
      <path d="M 38 22 L 31 22 L 29 20" stroke="#FFFFFF" stroke-width="1.2" fill="none" opacity="0.7" stroke-linecap="round"/>
      <circle cx="38" cy="22" r="1.5" fill="#FFFFFF" opacity="0.7"/>
    </g>
    <text x="48" y="30" font-family="'Segoe UI', 'Helvetica Neue', Arial, sans-serif" font-size="28" font-weight="bold" fill="url(#gxpms-logo-grad)">GXPMS</text>
  </svg>
`;
